<style>

    .v-event-book-checkmark {
        color: white;
        position: absolute;
        top:0px;
        right:5px;
        font-size: 20px;
    }

</style>
<template>
    <div class="animated fadeIn v-event-book">
        <b-card>
            <Request
                    ref="requestDates"
                    :onRequestSuccess="updateEvents"
                    root="/event-booking/dates">
                <slot slot="body">

                    <b-row>
                        <b-col v-if="Core.Value.encode(Core.Session.Setting.getSetting('event.filterBranch'),'checkbox')" sm="12" lg="6">
                            <b-form-group
                                    class="c-text"
                                    :label="Core.Definition.getDefinition('Établissement')">
                                <select @change="search" v-model="dataFilter.branchId" class="form-control mt-1">
                                    <option value=''>{{Core.Definition.getDefinition('Tous')}}</option>
                                    <option :value="branch.value" v-for="branch in dataSelectOptions.branchId">
                                        {{branch.label}}
                                    </option>
                                </select>
                            </b-form-group>
                        </b-col>
                        <b-col v-if="Core.Value.encode(Core.Session.Setting.getSetting('event.filterEvent'),'checkbox')" sm="12" lg="6">
                            <b-form-group
                                    class="c-text"
                                    :label="Core.Definition.getDefinition('Événement')">
                                <select @change="search"  v-model="dataFilter.eventId" class="form-control mt-1">
                                    <option value=''>{{Core.Definition.getDefinition('Tous')}}</option>
                                    <option :value="event.value" v-for="event in dataSelectOptions.eventId">
                                        {{event.label}}
                                    </option>
                                </select>
                            </b-form-group>
                        </b-col>
                        <b-col v-if="Core.Value.encode(Core.Session.Setting.getSetting('event.filterResponsable'),'checkbox')" sm="12" lg="6">
                            <b-form-group
                                    class="c-text"
                                    :label="Core.Definition.getDefinition('Responsable')">
                                    <select @change="search"  v-model="dataFilter.userId" class="form-control mt-1">
                                        <option value=''>{{Core.Definition.getDefinition('Tous')}}</option>
                                        <option :value="user.value" v-for="user in dataSelectOptions.userId">
                                            {{user.label}}
                                        </option>
                                    </select>
                            </b-form-group>
                        </b-col>
                        <b-col v-if="Core.Value.encode(Core.Session.Setting.getSetting('event.filterType'),'checkbox')" sm="12" lg="6">
                            <div class="mt-2">
                                <b-form-group
                                        class="c-text"
                                        :label="Core.Definition.getDefinition('Type d\'événement')">
                                    <select @change="search"  v-model="dataFilter.type" class="form-control mt-1">
                                        <option value=''>{{Core.Definition.getDefinition('Tous')}}</option>
                                        <option :value="type.value" v-for="type in dataSelectOptions.type">
                                            {{type.label}}
                                        </option>
                                    </select>
                                </b-form-group>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row class="mb-2 mt-2">
                        <b-col lg="6">

                        </b-col>
                        <b-col lg="6" class="text-right">
                            <b-button-group class="mt-3">
                                <b-button @click="switchDisplay(Mantle.EventBook.displayList)" :class="{ 'btn-light': (dataDisplay === Mantle.EventBook.displayCalendarWeek || dataDisplay === Mantle.EventBook.displayCalendarMonth), 'btn-primary': dataDisplay === Mantle.EventBook.displayList }" class="btn"><i class="fa fa-list mr-1"></i>{{Core.Definition.getDefinition('Liste')}}</b-button>
                                <b-button @click="switchDisplay(Mantle.EventBook.displayCalendarWeek)" :class="{ 'btn-primary': dataDisplay === Mantle.EventBook.displayCalendarWeek, 'btn-light': (dataDisplay === Mantle.EventBook.displayList || dataDisplay === Mantle.EventBook.displayCalendarMonth) }" class="btn"><i class="fa fa-calendar mr-1"></i>{{Core.Definition.getDefinition('Semaine')}}</b-button>
                                <b-button v-if="!Core.Display.isMobile()" @click="switchDisplay(Mantle.EventBook.displayCalendarMonth)" :class="{ 'btn-primary': dataDisplay === Mantle.EventBook.displayCalendarMonth, 'btn-light': (dataDisplay === Mantle.EventBook.displayList || dataDisplay === Mantle.EventBook.displayCalendarWeek) }" class="btn"><i class="fa fa-calendar-o mr-1"></i>{{Core.Definition.getDefinition('Mois')}}</b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <hr/>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2 mb-4">
                        <b-col class="text-center">
                            <WeekPagination v-model="dataWeekPagination"></WeekPagination>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div v-if="dataDisplay === Mantle.EventBook.displayList" class="animated fadeIn">
                                <EventList
                                        ref="eventList"
                                        v-if="dataEventDates.length > 0"
                                        :events="dataEventDates"
                                        :displayEditMode="false"
                                        @onMessagesClick="onMessagesClick"
                                        @onBookingsClick="onBookingsClick"
                                        @onBookClick="onBookClick"></EventList>
                            </div>
                            <div v-if="dataDisplay === Mantle.EventBook.displayCalendarWeek" class="animated fadeIn">
                                <CalendarWeek
                                        v-if="dataDisplay === Mantle.EventBook.displayCalendarWeek"
                                        ref="calendarWeek"
                                        v-model="dataWeekPagination.start"
                                        :events="dataEventDates"
                                        :renderEventContent="renderEventContent"
                                        @onEventClick="onBookClick">
                                </CalendarWeek>
                            </div>
                            <div v-if="dataDisplay === Mantle.EventBook.displayCalendarMonth" class="animated fadeIn">
                                <CalendarMonth
                                        v-if="dataDisplay === Mantle.EventBook.displayCalendarMonth"
                                        ref="calendarMonth"
                                        :renderEventContent="renderEventContent"
                                        @onEventClick="onBookClick"
                                        v-model="dataWeekPagination.start">
                                </CalendarMonth>
                            </div>
                        </b-col>
                    </b-row>
                </slot>
            </Request>
        </b-card>

        <Modal
                ref="modalConfirmEventBook"
                :hideFooter="true"
                :caption="dataEventDate.title">
            <slot slot="body">
                <Request
                        ref="requestEventBookConfirm"
                        method="POST"
                        :onRequestSuccess="onRequestEventBookSuccess"
                        root="/event-booking/confirm">
                    <slot slot="body">

                        <b-row class="mb-4 text-right">
                            <b-col>
                                <b-button-group>
                                    <b-button v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayMessage'),'checkbox')" @click="onMessagesClick(dataEventDate)" class="btn btn-light btn-sm"><i class="fa fa-comment"></i> {{Core.Text.format(Core.Definition.getDefinition('{0} messages'), dataEventDate.eventDateMessageCount)}}</b-button>
                                    <b-button v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayParticipant'),'checkbox')" @click="onBookingsClick(dataEventDate)" class="btn btn-light btn-sm ml-1"><i class="fa fa-users"></i> {{Mantle.Event.readableBookingCount(dataEventDate.eventDateBookingCount, dataEventDate.max)}}</b-button>
                                </b-button-group>
                            </b-col>
                        </b-row>

                        <b-row v-if="!Core.Validation.isEmpty(dataEventDate.eventDateUsers)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayResponsable'),'checkbox')">
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Responsables')">
                                    <label>{{Mantle.Event.readableResponsables(dataEventDate.eventDateUsers)}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Début')">
                                    <label>{{Vue.moment(dataEventDate.start).format('dddd, DD MMM YYYY HH:mm')}}</label>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Fin')">
                                    <label>{{Vue.moment(dataEventDate.end).format('dddd, DD MMM YYYY HH:mm')}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col v-if="!Core.Validation.isEmpty(dataEventDate.local)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayLocal'),'checkbox')">
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Local')">
                                    <label>{{Mantle.Event.readablePlace(dataEventDate.local)}}</label>
                                </b-form-group>
                            </b-col>
                            <b-col v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayMinMax'),'checkbox')">
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Min / Max')">
                                    <label v-html="Mantle.Event.readableMinMax(dataEventDate.min, dataEventDate.max)"></label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row v-if="!Core.Validation.isEmpty(dataEventDate.description)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayDescription'),'checkbox')">
                            <b-col>
                                <label>{{Core.Definition.getDefinition('Description')}}</label>
                                <div v-html="dataEventDate.description"></div>
                            </b-col>
                        </b-row>

                        <b-row v-if="dataEventDate.isVirtual != 1&&Core.Session.AuthUser.isAuth()">
                            <b-col>
                                <hr/>
                                <b-form-group
                                        v-if="dataChildrens.length === 0"
                                        class="mb-0"
                                        :label="Core.Definition.getDefinition('Nombre de place(s) réservée(s)')"
                                        :labelCols="6">
                                    <InputQuantity v-model="dataEventDate.quantity"></InputQuantity>
                                </b-form-group>

                                <div v-if="dataChildrens.length > 0">
                                    <strong>{{Core.Definition.getDefinition('Cliquez pour sélectionner le participant')}}</strong><br/><br/>
                                    <b-button-group>
                                        <b-button v-for="children in dataChildrens" @click="selectChildren(children.id)" :class="{ 'btn-light': childrenIsSelected(children.id) === false, 'btn-success' : childrenIsSelected(children.id)}" class="btn">{{children.firstname}} {{children.lastname}}</b-button>
                                    </b-button-group>

                                    <b-alert class="mt-2" v-if="dataShowChildrenAlert" show variant="danger">
                                        {{Core.Definition.getDefinition('Vous devez sélectionner au moins 1 participant à l\'événement')}}
                                    </b-alert>
                                </div>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <hr/>
                                <CForm ref="integratedForm" v-if="hasIntegratedFormTemplate(dataEventDate)" :structure="getIntegratedFormStructure(dataEventDate.formTemplateId)"></CForm>
                            </b-col>
                        </b-row>
                    </slot>
                </Request>

                <b-alert v-if="parseInt(dataEventDate.max) !== 0 && (parseInt(dataEventDate.eventDateBookingCount) + parseInt(dataEventDate.quantity) > parseInt(dataEventDate.max))" show variant="warning">
                    {{Core.Definition.getDefinition('Cet événement est plein, vous serez ajouté à la liste d\'attente. Vous recevrez  une confirmation de participation seulement si une place se libère.')}}
                </b-alert>

                <b-alert v-if="dataDisplayRequiredField" show variant="danger">
                    {{Core.Definition.getDefinition('Vous devez compléter les champs requis avant de réserver.')}}
                </b-alert>

                <div class="text-right">
                    <b-button-group>
                        <b-button @click="$refs.modalConfirmEventBook.open=false" class="btn btn-light">{{Core.Definition.getDefinition('Fermer')}}</b-button>

                        <b-button v-if="Core.Session.AuthUser.isAuth()&&Core.Value.encode(dataEventDate.bookingIsEnabled, Core.Value.typeCheckbox)" @click="onConfirmEventBook" class="btn btn-primary">
                            <template v-if="parseInt(dataEventDate.max) !== 0 && parseInt(dataEventDate.eventDateBookingCount) >= parseInt(dataEventDate.max)">{{Core.Definition.getDefinition('S\'inscrire sur la liste d\'attente')}}</template>
                            <template v-if="parseInt(dataEventDate.max)== 0 || (parseInt(dataEventDate.max) > 0 && parseInt(dataEventDate.eventDateBookingCount) < parseInt(dataEventDate.max))">{{Core.Definition.getDefinition('Réserver')}}</template>
                        </b-button>

                        <b-button v-if="false" @click="onFreeTryClick"  class="btn btn-light">{{Core.Definition.getDefinition('Essai gratuit')}}</b-button>

                        <b-button v-if="!Core.Session.AuthUser.isAuth()" @click="onCreateAccountClick" class="btn btn-light">{{Core.Definition.getDefinition('Créer un compte')}}</b-button>
                        <b-button v-if="!Core.Session.AuthUser.isAuth()" @click="onLoginClick"  @onCreateAccountClick="onCreateAccountClick" @onLoginSuccess="onLoginSuccess" variant="primary" class="btn">{{Core.Definition.getDefinition('Connexion')}}</b-button>
                    </b-button-group>

                </div>
            </slot>
        </Modal>

        <Modal
                ref="modalConfirmEventBookUpdate"
                :caption="dataEventDate.title"
                :hideFooter="true">
            <slot slot="body">
                <Request
                        ref="requestEventBookUpdate"
                        method="PUT"
                        :onRequestSuccess="onRequestEventBookSuccess"
                        root="/event-booking/update">
                    <slot slot="body">
                        <b-alert show variant="info">
                            <i class="fa fa-info-circle mr-2"></i>{{Core.Definition.getDefinition('Vous avez réservé pour cet événement')}}
                        </b-alert>

                        <b-row class="mb-4 text-right">
                            <b-col>
                                <b-button-group>
                                    <b-button v-if="false" class="btn btn-light"><i class="fa fa-video-camera mr-2"></i>{{Core.Definition.getDefinition('Rejoindre la salle virtuelle')}}</b-button>
                                    <b-button v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayMessage'),'checkbox')" @click="onMessagesClick(dataEventDate)" class="btn btn-light btn-sm"><i class="fa fa-comment"></i> {{Core.Text.format(Core.Definition.getDefinition('{0} messages'), dataEventDate.eventDateMessageCount)}}</b-button>
                                    <b-button v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayParticipant'),'checkbox')" @click="onBookingsClick(dataEventDate)" class="btn btn-light btn-sm ml-1"><i class="fa fa-users"></i> {{Mantle.Event.readableBookingCount(dataEventDate.eventDateBookingCount, dataEventDate.max)}}</b-button>
                                </b-button-group>
                            </b-col>
                        </b-row>

                        <b-row v-if="!Core.Validation.isEmpty(dataEventDate.eventDateUsers)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayResponsable'),'checkbox')">
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Responsables')">
                                    <label>{{Mantle.Event.readableResponsables(dataEventDate.eventDateUsers)}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Début')">
                                    <label>{{Vue.moment(dataEventDate.start).format('dddd, DD MMM YYYY HH:mm')}}</label>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Fin')">
                                    <label>{{Vue.moment(dataEventDate.end).format('dddd, DD MMM YYYY HH:mm')}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col v-if="!Core.Validation.isEmpty(dataEventDate.local)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayLocal'),'checkbox')">
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Local')">
                                    <label>{{Mantle.Event.readablePlace(dataEventDate.local)}}</label>
                                </b-form-group>
                            </b-col>
                            <b-col v-if="Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayMinMax'),'checkbox')">
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Min / Max')">
                                    <label v-html="Mantle.Event.readableMinMax(dataEventDate.min, dataEventDate.max)"></label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row v-if="!Core.Validation.isEmpty(dataEventDate.description)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayDescription'),'checkbox')">
                            <b-col>
                                <hr/>
                                <strong>{{Core.Definition.getDefinition('Description')}}</strong>
                                <div v-html="dataEventDate.description"></div>
                            </b-col>
                        </b-row>

                        <b-row v-if="false">
                            <b-col>
                                <hr/>
                                <b-form-group
                                        class="mb-0"
                                        :label="Core.Definition.getDefinition('Nombre de place(s) réservée(s)')"
                                        :labelCols="6">
                                    <InputQuantity v-model="dataEventDate.eventDateBooking.quantity"></InputQuantity>
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </slot>
                </Request>
                <hr/>
                <div class="text-right">
                    <b-button-group>
                        <b-button @click="$refs.modalConfirmEventBookUpdate.open=false" class="btn btn-light">{{Core.Definition.getDefinition('Fermer')}}</b-button>
                        <b-button @click="onCancelClick" class="btn btn-danger">{{Core.Definition.getDefinition('Annuler la réservation')}}</b-button>
                        <b-button v-if="false" @click="onConfirmEventBookUpdate" class="btn btn-primary">{{Core.Definition.getDefinition('Enregistrer')}}</b-button>
                    </b-button-group>
                </div>
            </slot>
        </Modal>

        <Modal
                ref="modalConfirmEventBookCancel"
                :caption="dataEventDate.title"
                :hideFooter="true">
            <slot slot="body">
                <Request
                        ref="requestEventBookCancel"
                        method="PUT"
                        :onRequestSuccess="onRequestEventBookSuccess"
                        root="/event-booking/cancel">
                    <slot slot="body">
                        <b-alert show variant="danger">
                            <i class="fa fa-question-circle mr-2"></i>{{Core.Definition.getDefinition('Êtes-vous sûr de vouloir annuler votre réservation?')}}
                        </b-alert>

                        <b-alert v-if="dataEventDate.bookingCancelAlert" show variant="danger">
                            <i class="fa fa-warning mr-2"></i>{{Core.Definition.getDefinition('Attention. Si cette réservation est associée à un abonnement limité, il est possible que votre scéance ne soit pas remise à votre abonnement.')}}
                        </b-alert>

                        <b-row v-if="!Core.Validation.isEmpty(dataEventDate.eventDateUsers)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayResponsable'),'checkbox')">
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Responsables')">
                                    <label>{{Mantle.Event.readableResponsables(dataEventDate.eventDateUsers)}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Début')">
                                    <label>{{Vue.moment(dataEventDate.start).format('dddd, DD MMM YYYY HH:mm')}}</label>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Fin')">
                                    <label>{{Vue.moment(dataEventDate.end).format('dddd, DD MMM YYYY HH:mm')}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row v-if="!Core.Validation.isEmpty(dataEventDate.local)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayLocal'),'checkbox')">
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Local')">
                                    <label>{{Mantle.Event.readablePlace(dataEventDate.local)}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row v-if="dataEventDate.eventDateBooking !== undefined">
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Nombre de place(s) réservée(s)')"
                                        :labelCols="6">
                                    <label class="mt-2">{{dataEventDate.eventDateBooking.quantity}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </slot>
                </Request>
                <hr/>
                <div class="text-right">
                    <b-button-group>
                        <b-button @click="$refs.modalConfirmEventBookCancel.open=false" class="btn btn-light">{{Core.Definition.getDefinition('Fermer')}}</b-button>
                        <b-button @click="onConfirmEventBookCancel" class="btn btn-danger">{{Core.Definition.getDefinition('Annuler la réservation')}}</b-button>
                    </b-button-group>
                </div>
            </slot>
        </Modal>

        <Modal
                size="m"
                ref="modalInstanceSelectorNewPurchase"
                :caption="Core.Definition.getDefinition('Achat requis')"
                :hideFooter="true">
            <slot slot="body">

                <b-alert show variant="warning">
                    {{Core.Definition.getDefinition('L\'événement sélectionné requiert l\'achat d\'un des produits suivant. Vous devez compléter l\'achat pour réserver.')}}
                </b-alert>

                <EmbeddedPurchase
                        ref="embeddedPurchase"
                        @onSuccess="onSuccessEmbeddedPurchase"
                        :product="product"
                        :eventDateId="dataEventDate.id"
                        :searchArgs="[
                            {
                                key: 'id',
                                value: dataRequiredProductIds
                            }
                        ]">
                </EmbeddedPurchase>
            </slot>
        </Modal>

        <ModalLogin
                ref="modalLogin"
                @onCreateAccountClick="onCreateAccountClick"
                @onLoginSuccess="onLoginSuccess">
        </ModalLogin>

        <ModalCreateAccount
                @onLoginClick="onLoginClick"
                :caption="Core.Definition.getDefinition('Nouveau compte')"
                ref="modalCreateAccount">
        </ModalCreateAccount>

        <Modal
                size="m"
                ref="modalMessages"
                :caption="Core.Definition.getDefinition('Messages')"
                :hideFooter="true">
            <slot slot="body">
                <Request
                        @onInit="onInitEventDateMessages"
                        ref="requestEventDateMessages"
                        :onRequestSuccess="onRequestSuccessEventDateMessages"
                        root="/event-booking/messages">
                    <slot slot="body">
                        <div v-if="dataEventDateMessages.length > 0">
                            <div v-for="eventDateMessage in dataEventDateMessages">
                                <div class="message">
                                    <div>
                                        <small class="text-muted float-right mt-1 mr-3">{{Core.Date.readableDate(eventDateMessage.date)}}</small>
                                    </div>
                                    <div class="text-truncate font-weight-bold mt-2 mb-2">{{eventDateMessage.message}}</div>
                                </div>
                                <hr/>
                            </div>
                        </div>
                        <b-alert v-else show variant="light">
                            {{Core.Definition.getDefinition('Aucune message pour cet événement.')}}
                        </b-alert>
                    </slot>
                </Request>

            </slot>
        </Modal>

        <Modal
                size="m"
                ref="modalBookings"
                :caption="Core.Definition.getDefinition('Participants')"
                :hideFooter="true">
            <slot slot="body">
                <Request
                        @onInit="onInitEventDateBookings"
                        ref="requestEventDateBookings"
                        :onRequestSuccess="onRequestSuccessEventDateBookings"
                        root="/event-booking/bookings">
                    <slot slot="body">
                        <table class="table table-striped table-borderless" v-if="dataEventDateBookings.length > 0">
                            <tbody>
                                <tr v-for="eventDateBooking in dataEventDateBookings">
                                    <td width="20px">
                                        <i class="fa fa-user"></i>
                                    </td>
                                    <td>
                                        {{eventDateBooking.userFirstname}} {{eventDateBooking.userLastname}}
                                    </td>
                                    <td>
                                        {{Core.Date.format(eventDateBooking.bookDate)}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <b-alert v-else show variant="light">
                            {{Core.Definition.getDefinition('Aucun participant pour cet événement.')}}
                        </b-alert>
                    </slot>
                </Request>
            </slot>
        </Modal>

        <Modal
                ref="modalConfirmEventBookPreview"
                :caption="dataEventDate.title"
                :hideFooter="true">
            <slot slot="body">
                        <b-row v-if="!Core.Validation.isEmpty(dataEventDate.eventDateUsers)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayResponsable'),'checkbox')">
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Responsables')">
                                    <label>{{Mantle.Event.readableResponsables(dataEventDate.eventDateUsers)}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Début')">
                                    <label>{{Vue.moment(dataEventDate.start).format('dddd, DD MMM YYYY HH:mm')}}</label>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Fin')">
                                    <label>{{Vue.moment(dataEventDate.end).format('dddd, DD MMM YYYY HH:mm')}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row v-if="!Core.Validation.isEmpty(dataEventDate.local)&&Core.Value.encode(Core.Session.Setting.getSetting('environment.ui.event.displayLocal'),'checkbox')">
                            <b-col>
                                <b-form-group
                                        :label="Core.Definition.getDefinition('Local')">
                                    <label>{{Mantle.Event.readablePlace(dataEventDate.local)}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                <b-alert show variant="success">
                    <i class="fa fa-info-circle mr-2"></i>{{Core.Definition.getDefinition('Votre réservation est maintenant confirmée!')}}
                </b-alert>
            </slot>
        </Modal>

    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import Request from '../../components/Request'
    import CalendarWeek from '../../components/CalendarWeek'
    import CalendarMonth from '../../components/CalendarMonth'
    import EventList from '../../components/EventList'
    import WeekPagination from '../../components/WeekPagination'
    import ModalConfirm from '../../components/ModalConfirm'
    import InputQuantity from '../../components/InputQuantity'
    import InstanceSelector from '../../components/InstanceSelector'
    import Modal from '../../components/Modal'
    import ModalLogin from '../../components/ModalLogin'
    import ModalCreateAccount from '../../components/ModalCreateAccount'
    import EmbeddedPurchase from '../../components/EmbeddedPurchase'
    import CForm from '../../components/CForm'
    import PluginRequest from '../../components/PluginRequest'
    export default {
        name: 'EventBooking',
        components: {
            CalendarWeek,
            CalendarMonth,
            WeekPagination,
            EventList,
            ModalConfirm,
            Request,
            InputQuantity,
            InstanceSelector,
            Modal,
            ModalLogin,
            ModalCreateAccount,
            EmbeddedPurchase,
            CForm,
            PluginRequest
        },
        props: {
            purchaseRedirectType: {
                type: String,
                default: 'router'
            },
            purchaseRedirectUrl: {
                type: String,
                default: ''
            },
            minBookingLeft: {
                type: String | Number,
                default: ''
            },
            productId: {
                type: String | Number,
                default: ''
            },
            product: {
                type: Object,
                default: function() {
                    return {}
                }
            }
        },
        watch: {
            dataNewPurchase: {
                handler(val) {
                    let product = val[0].instance
                    let append = true
                    switch(product.type) {
                        case Core.Product.typeOrder:
                            break
                        case Core.Product.typeLimitedSubscription:
                            append = false
                            break
                        case Core.Product.typeRecurringSubscription:
                            append = false
                            break
                    }
                    if (product.quantity === undefined) {
                        product.quantity = 1
                    }
                    Core.Session.Cart.add(product, append)

                    let purchaseRedirectUrl = ''
                    if (this.purchaseRedirectUrl !== '') {
                        purchaseRedirectUrl = this.purchaseRedirectUrl
                    }

                    switch(this.purchaseRedirectType) {
                        case Mantle.EventBook.purchaseRedirectTypeEmbedded:

                            break
                        case Mantle.EventBook.purchaseRedirectTypeUrl:
                            if (purchaseRedirectUrl!=='') {
                                window.open(purchaseRedirectUrl);
                            }
                            break
                        case Mantle.EventBook.purchaseRedirectTypeRouter:
                            if (purchaseRedirectUrl==='') {
                                purchaseRedirectUrl = Core.Definition.getDefinition('/commerce/boutique/panier')
                            }
                            this.$router.push(purchaseRedirectUrl)
                            break
                    }
                },
                deep: true
            },
            dataWeekPagination: {
                handler(val) {
                    let groupBy = ''
                    if(this.dataDisplay === Mantle.EventBook.displayList) {
                        groupBy = 'date'
                    }
                    this.request(val.start, val.end, groupBy)
                },
                deep: true
            }
        },
        mounted() {

            if (Core.Validation.isId(this.$route.params.responsableId)) {
                this.dataFilter.userId = this.$route.params.responsableId
            }

            if (Core.Validation.isId(this.$route.params.eventId)) {
                this.dataFilter.eventId = this.$route.params.eventId
            }

            if (this.$route.params.eventType !== undefined) {
                this.dataFilter.type = this.$route.params.eventType
            }

            if (Core.Validation.isId(this.$route.params.branchId)) {
                this.dataFilter.branchId = this.$route.params.branchId
            }

            if (Core.Validation.isId(this.productId)) {
                this.dataFilter.productId = this.productId
            }

            if (this.minBookingLeft !== '') {
                this.dataFilter.minBookingLeft = this.minBookingLeft
            }
        },
        data: function () {
            return {
                Vue: Vue,
                Core: window.Core,
                Mantle: window.Mantle,
                dataForms: [],
                dataDisplay: Mantle.EventBook.displayList,
                dataWeekPagination: {
                    start: Core.Date.getToday('YYYY-MM-DD'),
                    end: ''
                },
                dataFilter: {
                    type: '',
                    userId: '',
                    eventId: '',
                    branchId: '',
                    productId: '',
                    minBookingLeft: ''
                },
                dataEventDates: [],
                dataSelectOptions: {
                    userId: [],
                    eventId: [],
                    type: [],
                    branchId: []
                },
                dataEventDate: {},
                dataActivePurchases: {},
                dataChildrens: [],
                dataNewPurchase: [],
                dataRequiredProductIds: [],
                dataEventDateMessages: [],
                dataEventDateBookings: [],
                dataEventDateId: 0,
                dataSelectedChildrens: [],
                dataShowChildrenAlert: false,
                dataDisplayRequiredField: false,
                dataOpenAfterConnect: ''
            }
        },
        computed: {
        },
        methods: {
            getIntegratedFormStructure(formTemplateId) {
                if(Core.Validation.isId(formTemplateId)) {
                    if (this.dataForms[formTemplateId] !== undefined) {
                        return this.dataForms[formTemplateId]
                    }
                }
                return {}
            },
            getIntegratedFormTemplateId(eventDate) {
                if (eventDate.formTemplateId !== undefined) {
                    if(Core.Validation.isId(eventDate.formTemplateId)) {
                        if (this.dataForms[eventDate.formTemplateId] !== undefined) {
                            return eventDate.formTemplateId
                        }
                    }
                }
                return false
            },
            hasIntegratedFormTemplate(eventDate) {
                if (eventDate.formTemplateId !== undefined) {
                    if(Core.Validation.isId(eventDate.formTemplateId)) {
                        if (this.dataForms[eventDate.formTemplateId] !== undefined) {
                            return true
                        }
                    }
                }
                return false
            },
            search() {
                let groupBy = ''
                if(this.dataDisplay === Mantle.EventBook.displayList) {
                    groupBy = 'date'
                }
                this.request(this.dataWeekPagination.start, this.dataWeekPagination.end, groupBy)
            },
            switchDisplay(display) {
                this.dataEventDates = []
                this.dataDisplay = display
                let groupBy = ''
                if(display === Mantle.EventBook.displayList) {
                    groupBy = 'date'
                }
                this.request(this.dataWeekPagination.start, this.dataWeekPagination.end, groupBy)
            },
            renderEventContent(event) {
                let content = ''
                if (event.eventDateUsers != null) {
                    content = "<small>" + event.eventDateUsers + "</small>"
                }
                if (event.finished !== undefined && event.finished == 1) {
                    content += "<small style='display:block'>" + Core.Definition.getDefinition('Terminé') + "</small>"
                } else {
                    content += "<small style='display:block'>" + Vue.moment(event.start).format('HH:mm') + ' - ' + Vue.moment(event.end).format('HH:mm') + "</small>"
                }
                if (event.eventDateBooking !== undefined) {
                    switch(event.eventDateBooking.status) {
                        case Mantle.EventDateBooking.statusCancelled:
                            content = content + "<div class='v-event-book-checkmark'><i class='fa fa-times'></i></div>"
                            break
                        case Mantle.EventDateBooking.statusWaiting:
                            content = content + "<div class='v-event-book-checkmark'><i class='fa fa-hourglass-1'></i></div>"
                            break
                        default:
                            content = content + "<div class='v-event-book-checkmark'><i class='fa fa-check-circle'></i></div>"
                            break
                    }
                }
                return content
            },
            request(start, end, groupBy) {
                this.$refs.requestDates.clearArgs()
                this.$refs.requestDates.addArg('start', start)
                this.$refs.requestDates.addArg('end', end)
                this.$refs.requestDates.addArg('groupBy', groupBy)
                this.$refs.requestDates.addArg('type', this.dataFilter.type)
                this.$refs.requestDates.addArg('userId', this.dataFilter.userId)
                this.$refs.requestDates.addArg('eventId', this.dataFilter.eventId)
                this.$refs.requestDates.addArg('branchId', this.dataFilter.branchId)
                this.$refs.requestDates.addArg('minBookingLeft', this.dataFilter.minBookingLeft)
                this.$refs.requestDates.addArg('productId', this.dataFilter.productId)
                this.$refs.requestDates.request()
            },
            updateEvents(data) {
                if (data.eventDates !== undefined) {
                    this.dataEventDates = data.eventDates

                    if(this.$refs.calendarWeek !== undefined) {
                        this.$refs.calendarWeek.clearEvents()
                        if (data.eventDates.length > 0) {
                            for(let eventDate in data.eventDates) {
                                eventDate = data.eventDates[eventDate]
                                this.$refs.calendarWeek.updateEvent(eventDate)
                            }
                        }
                    }

                    if(this.$refs.calendarMonth !== undefined) {
                        this.$refs.calendarMonth.clearEvents()
                        if (data.eventDates.length > 0) {
                            for(let eventDate in data.eventDates) {
                                eventDate = data.eventDates[eventDate]
                                this.$refs.calendarMonth.updateEvent(eventDate)
                            }
                        }
                    }

                    if(this.$refs.eventList !== undefined) {
                        this.$refs.eventList.clearEvents()
                        this.$refs.eventList.dataEvents = data.eventDates
                    }

                }
                if (data.selectOptions !== undefined) {
                    this.dataSelectOptions = data.selectOptions
                }
                if (data.activePurchases) {
                    this.dataActivePurchases = data.activePurchases
                }
                if (data.childrens) {
                    this.dataChildrens = data.childrens
                }
                if (data.forms) {
                    this.dataForms = data.forms
                }
            },
            userHasRequiredProduct(requiredProductIds) {
                if (requiredProductIds.length>0) {
                    if (this.dataActivePurchases[0] !== undefined) {
                        let orderProductIds = this.dataActivePurchases[0].orderProductIds
                        let limitedSubscriptionProductIds = this.dataActivePurchases[0].limitedSubscriptionProductIds
                        let recurringSubscriptionProductIds = this.dataActivePurchases[0].recurringSubscriptionProductIds

                        // Pourquoi une commande?
                        // Une commande devrait toujours être achetée durant le processus de réservation,
                        /*
                        if(orderProductIds !== null) {
                            orderProductIds = orderProductIds.split(',')
                            for(let orderProductId in orderProductIds) {
                                orderProductId = orderProductIds[orderProductId]
                                for(let requiredProductId in requiredProductIds) {
                                    requiredProductId = requiredProductIds[requiredProductId]
                                    if (orderProductId.toString() === requiredProductId.toString()) {
                                        return true
                                    }
                                }
                            }
                        }
                         */

                        if(limitedSubscriptionProductIds !== null) {
                            limitedSubscriptionProductIds = limitedSubscriptionProductIds.split(',')
                            for(let limitedSubscriptionProductId in limitedSubscriptionProductIds) {
                                limitedSubscriptionProductId = limitedSubscriptionProductIds[limitedSubscriptionProductId]
                                for(let requiredProductId in requiredProductIds) {
                                    requiredProductId = requiredProductIds[requiredProductId]
                                    if (limitedSubscriptionProductId.toString().trim() === requiredProductId.toString().trim()) {
                                        return true
                                    }
                                }
                            }
                        }

                        if(recurringSubscriptionProductIds !== null) {
                            recurringSubscriptionProductIds = recurringSubscriptionProductIds.split(',')
                            for(let recurringSubscriptionProductId in recurringSubscriptionProductIds) {
                                recurringSubscriptionProductId = recurringSubscriptionProductIds[recurringSubscriptionProductId]
                                for(let requiredProductId in requiredProductIds) {
                                    requiredProductId = requiredProductIds[requiredProductId]
                                    if (recurringSubscriptionProductId.toString().trim() === requiredProductId.toString().trim()) {
                                        return true
                                    }
                                }
                            }
                        }
                        return false
                    } else {
                        return false
                    }
                }
                return true
            },
            onBookClick(event) {

                if (event.bookingIsEnabled == 1) {

                    this.dataShowChildrenAlert = false
                    this.dataEventDate = event

                    if (!Core.Session.AuthUser.isAuth()) {
                        this.onLoginClick()
                        return false
                    }

                    this.selectPrincipalChildren()

                    if (event.eventDateBooking !== undefined && event.eventDateBooking.status !== Mantle.EventDateBooking.statusCancelled) {
                        this.$refs.modalConfirmEventBookUpdate.open = true
                        return false
                    }

                    if(event.eventDateProductIds !== '' && event.eventDateProductIds !== null && event.eventDateProductIds !== 'null' && event.eventDateProductIds !== undefined && event.forcePurchase == 1) {
                        let requiredProductIds = event.eventDateProductIds.split(',')
                        if(!this.userHasRequiredProduct(requiredProductIds)) {
                            this.dataRequiredProductIds = requiredProductIds
                            this.$refs.modalInstanceSelectorNewPurchase.open = true
                            return false
                        }
                    }

                    if (event.eventDateBooking !== undefined && event.eventDateBooking.status !== Mantle.EventDateBooking.statusCancelled) {
                        this.$refs.modalConfirmEventBookUpdate.open = true
                    } else {
                        this.$refs.modalConfirmEventBook.open = true
                    }
                }
            },
            onSuccessEmbeddedPurchase(purchases, referenceNumber, eventDateId) {

                let limitedSubscriptionProductIds = this.dataActivePurchases[0].limitedSubscriptionProductIds
                let recurringSubscriptionProductIds = this.dataActivePurchases[0].recurringSubscriptionProductIds

                for(let purchase in purchases) {
                    purchase = purchases[purchase]

                    switch(purchase.type) {
                        case Core.Product.typeRecurringSubscription:
                            if(recurringSubscriptionProductIds !== null) {
                                recurringSubscriptionProductIds = recurringSubscriptionProductIds.split(',')
                            } else {
                                recurringSubscriptionProductIds = []
                            }
                            recurringSubscriptionProductIds.push(purchase.id)
                            this.dataActivePurchases[0].recurringSubscriptionProductIds = recurringSubscriptionProductIds.join(',')
                            break
                        case Core.Product.typeLimitedSubscription:
                            if(limitedSubscriptionProductIds !== null) {
                                limitedSubscriptionProductIds = limitedSubscriptionProductIds.split(',')
                            } else {
                                limitedSubscriptionProductIds = []
                            }
                            limitedSubscriptionProductIds.push(purchase.id)
                            this.dataActivePurchases[0].limitedSubscriptionProductIds = limitedSubscriptionProductIds.join(',')
                            break
                    }
                }

                this.$refs.modalInstanceSelectorNewPurchase.open = false

                if (!Core.Validation.isId(eventDateId)) {
                    this.$refs.modalConfirmEventBook.open = true
                } else {
                    this.$refs.modalConfirmEventBookPreview.open = true
                }
            },
            onCancelClick() {
                this.$refs.modalConfirmEventBookUpdate.open = false
                this.$refs.modalConfirmEventBookCancel.open = true
            },
            onConfirmEventBook() {
                if (this.dataChildrens.length > 0 && this.dataSelectedChildrens.length === 0) {
                    this.dataShowChildrenAlert = true
                } else {
                    this.$refs.modalConfirmEventBook.disableConfirm = true
                    this.$refs.requestEventBookConfirm.clearArgs()
                    if (this.$refs.integratedForm !== undefined) {
                        if (!this.$refs.integratedForm.validate()) {
                            this.dataDisplayRequiredField = true
                            return false
                        } else {
                            let form = {
                                formTemplateId: this.getIntegratedFormTemplateId(this.dataEventDate),
                                values: this.$refs.integratedForm.getValues()
                            }
                            this.$refs.requestEventBookConfirm.addArg('form', JSON.stringify(form))
                        }
                    }

                    this.$refs.requestEventBookConfirm.addArg('childrens', JSON.stringify(this.dataSelectedChildrens))
                    this.$refs.requestEventBookConfirm.addArg('eventDateId', this.dataEventDate.id)
                    this.$refs.requestEventBookConfirm.addArg('quantity', this.dataEventDate.quantity)
                    this.$refs.requestEventBookConfirm.request()
                }
            },
            onRequestEventBookSuccess(data) {
                if (data.alert === undefined) {
                    this.$refs.modalConfirmEventBook.disableConfirm = false
                    this.$refs.modalConfirmEventBookCancel.disableConfirm = false
                    this.$refs.modalConfirmEventBookUpdate.disableConfirm = false
                    if (data.eventDate !== undefined) {
                        this.$refs.modalConfirmEventBook.open = false
                        this.$refs.modalConfirmEventBookCancel.open = false
                        this.$refs.modalConfirmEventBookUpdate.open = false
                        if (data.eventDate !== undefined) {
                            if(this.$refs.eventList !== undefined) {
                                let event = this.$refs.eventList.getEvent(data.eventDate.id)
                                event.eventDateBooking = data.eventDate.eventDateBooking
                                this.$refs.eventList.updateEvent(event)
                            }
                            if(this.$refs.calendarWeek !== undefined) {
                                let eventIndex = Core.Array.findIndexByKey(this.$refs.calendarWeek.dataEvents, 'id', data.eventDate.id)
                                let event = this.$refs.calendarWeek.dataEvents[eventIndex]
                                event.eventDateBooking = data.eventDate.eventDateBooking
                                this.$refs.calendarWeek.updateEvent(event)
                            }
                        }
                    }
                }

                if (data.activePurchases) {
                    this.dataActivePurchases = data.activePurchases
                }
            },
            onConfirmEventBookCancel() {
                this.$refs.modalConfirmEventBookCancel.disableConfirm = true
                this.$refs.requestEventBookCancel.clearArgs()
                this.$refs.requestEventBookCancel.addArg('eventDateBookingId', this.dataEventDate.eventDateBooking.id)
                this.$refs.requestEventBookCancel.request()
            },
            onConfirmEventBookUpdate() {
                this.$refs.modalConfirmEventBookUpdate.disableConfirm = true
                this.$refs.requestEventBookUpdate.clearArgs()
                this.$refs.requestEventBookUpdate.addArg('eventDateBookingId', this.dataEventDate.eventDateBooking.id)
                this.$refs.requestEventBookUpdate.addArg('quantity', this.dataEventDate.eventDateBooking.quantity)
                this.$refs.requestEventBookUpdate.request()
            },
            onLoginClick() {
                this.$refs.modalCreateAccount.open = false
                this.$refs.modalConfirmEventBook.open = false
                this.$refs.modalLogin.open = true
            },
            onLoginSuccess() {
                this.$refs.modalLogin.open = false
                this.onBookClick(this.dataEventDate)
            },
            onCreateAccountClick() {
                this.$refs.modalConfirmEventBook.open = false
                this.$refs.modalCreateAccount.open = true
            },
            onFreeTryClick() {
                this.$refs.modalConfirmEventBook.open = false
            },
            onMessagesClick(eventDate) {
                this.dataEventDateId = eventDate.id
                this.$refs.modalMessages.open = true
            },
            onInitEventDateMessages() {
                this.$refs.requestEventDateMessages.clearArgs()
                this.$refs.requestEventDateMessages.addArg('id', this.dataEventDateId)
                this.$refs.requestEventDateMessages.request()
            },
            onRequestSuccessEventDateMessages(data){
                if (data.messages !== undefined) {
                    this.dataEventDateMessages = data.messages
                }
            },
            onBookingsClick(eventDate) {
                this.dataEventDateBookings = []
                this.dataEventDateId = eventDate.id
                this.$refs.modalBookings.open = true
            },
            onInitEventDateBookings() {
                this.$refs.requestEventDateBookings.clearArgs()
                this.$refs.requestEventDateBookings.addArg('id', this.dataEventDateId)
                this.$refs.requestEventDateBookings.request()
            },
            onRequestSuccessEventDateBookings(data){
                if (data.bookings !== undefined) {
                    this.dataEventDateBookings = data.bookings
                }
            },
            childrenIsSelected(childrenId) {
                for(let selectedChildrenIdIndex in this.dataSelectedChildrens) {
                    let selectedChildrenId = this.dataSelectedChildrens[selectedChildrenIdIndex]
                    if (selectedChildrenId.toString() === childrenId.toString()) {
                        return selectedChildrenIdIndex
                    }
                }
                return false
            },
            selectChildren(childrenId) {
                let selectedChildrenIdIndex = this.childrenIsSelected(childrenId)
                if (selectedChildrenIdIndex === false) {
                    this.dataSelectedChildrens.push(childrenId)
                } else {
                    if (this.dataChildrens.length > 1) {
                        this.dataSelectedChildrens.splice(selectedChildrenIdIndex, 1)
                    }
                }
            },
            resetSelectedChildrens() {
                this.dataSelectedChildrens = []
            },
            selectPrincipalChildren() {
                this.resetSelectedChildrens()
                for(let children in this.dataChildrens) {
                    children = this.dataChildrens[children]
                    this.selectChildren(children.id)
                    break
                }
            }
        }
    }
</script>
